import React from "react"
import clsx from "clsx"

import styles from "./notificationMessage.module.css"

const BULLET = /^\s*[-•]\s+/
const LABEL = /^[^.!?]{1,40}:$/

// Mensagens de notificação chegam do backend como texto corrido com quebras de linha.
// Aqui elas viram parágrafos, rótulos e listas — sem mudar o conteúdo.
export function parseBlocks(text) {
  const blocks = []

  for (const rawLine of text.split("\n")) {
    const line = rawLine.trim()
    if (!line) {
      continue
    }

    if (BULLET.test(line)) {
      const item = line.replace(BULLET, "")
      const last = blocks[blocks.length - 1]
      if (last && last.type === "list") {
        last.items.push(item)
      } else {
        blocks.push({ type: "list", items: [item] })
      }
      continue
    }

    blocks.push({ type: LABEL.test(line) ? "label" : "text", text: line })
  }

  return blocks
}

const NotificationMessage = ({ text, className, collapsed = false }) => {
  if (!text) {
    return null
  }

  return (
    <div className={clsx(styles.message, collapsed && styles.collapsed, className)}>
      {parseBlocks(text).map((block, index) => {
        if (block.type === "list") {
          return (
            <ul key={index} className={styles.list}>
              {block.items.map((item, itemIndex) => (
                <li key={itemIndex}>{item}</li>
              ))}
            </ul>
          )
        }

        if (block.type === "label") {
          return (
            <p key={index} className={styles.label}>
              {block.text}
            </p>
          )
        }

        return <p key={index}>{block.text}</p>
      })}
    </div>
  )
}

export default NotificationMessage
